/**
 * Global Styles — ClubSwap Brand v1.0
 *
 * Sets Poppins as the default font family for all text in the app.
 */

import { StyleSheet, TextStyle } from 'react-native';
import { Fonts } from './fonts';

export const defaultTextStyle: TextStyle = {
  fontFamily: Fonts.regular, // Poppins_400Regular
};

export const globalStyles = StyleSheet.create({
  text: {
    fontFamily: Fonts.regular,
  },
  textMedium: {
    fontFamily: Fonts.medium,
  },
  textSemiBold: {
    fontFamily: Fonts.semiBold,
  },
  textBold: {
    fontFamily: Fonts.bold,
  },
  textDisplay: {
    fontFamily: Fonts.display,
  },
  textDisplayBold: {
    fontFamily: Fonts.displayBold,
  },
  textDisplayItalic: {
    fontFamily: Fonts.displayItalic,
  },
});
